import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalSampleComponent } from './modal-sample.component';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [ModalSampleComponent],
  imports: [CommonModule, StaticMsgModule],
  exports: [ModalSampleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalSampleModule {}
